import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "The Key To Success",
  date: new Date(2024, 4, 5),
  img: "/img/cinco.jpeg",
  video: "/videos/cinco.mp4",
  tracks: [
    {
      title: "Gumdrops And Jellybeans",
      src: "/songs/2024-04-21/gumdrops_and_jellybeans.mp3",
      duration: 737.424,
    },
    {
      title: "All The Truth",
      src: "/songs/2024-04-21/all_the_truth.mp3",
      duration: 1075.776,
    },
    {
      title: "High Performance Sports Car",
      src: "/songs/2024-04-21/high_performance_sports_car.mp3",
      duration: 508.416,
    },
    {
      title: "Beans In The Kitchen",
      src: "/songs/2024-04-21/beans_in_the_kitchen.mp3",
      duration: 806.136,
    },
    {
      title: "Who Left The Seat Up?!",
      src: "/songs/2024-04-21/who_left_the_seat_up.mp3",
      duration: 951.936,
    },
    {
      title: "Get Me Through This, My Friend",
      src: "/songs/2024-04-21/get_me_through_this.mp3",
      duration: 777.072,
    },
    {
      title: "(You Don't) Own Me",
      src: "/songs/2024-04-21/you_dont_own_me.mp3",
      duration: 605.856,
    },
    {
      title: "Home Bound",
      src: "/songs/2024-04-21/home_bound.mp3",
      duration: 752.784,
    },
    {
      title: "Commercial Grade",
      src: "/songs/2024-04-21/commercial_grade.mp3",
      duration: 405.072,
    },
  ],
};
export default album;
